export const environment = {
  production: false,
  stage: 'staging',
  showMaintenancePitchbar: false,
  cypherSecret: '43e3b766be887ed244ea9749c116d5ca',
  storeUrl: 'https://stg.portfolio.familia.inteligenciadevida.com.br/meu-mundo'
};
